<div class="wizard-configuration">
    <div class="section-header">
        <span class="header-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.HEADER'|translate }}</span>
    </div>

    <!-- Camera List Table -->
    <div class="camera-list">
        <table class="camera-table ui-table">
            <thead>
                <tr>
                    <th class="checkbox-col">
                        <mat-checkbox [checked]="areAllSelected" [indeterminate]="selectedCount > 0 && !areAllSelected"
                            (change)="toggleAllCameras()"></mat-checkbox>
                    </th>
                    <th class="cameras-col">{{ 'ADD_CAMERA_WIZARD.AUTH.TABLE.CAMERAS'|translate }}</th>
                    <th class="autoconfig-col">
                        {{ 'ADD_CAMERA_WIZARD.CONFIGURATION.AUTO_CONFIG'|translate }}
                        <span class="ui-icon-info"
                            [matTooltip]="'ADD_CAMERA_WIZARD.CONFIGURATION.AUTO_CONFIG_TOOLTIP'|translate"
                            matTooltipPosition="above"></span>
                    </th>
                    <th class="mainstream-col">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.MAINSTREAM'|translate }}</th>
                    <th class="substream-col">{{ 'CAMERA_ACTIVATE_DIALOG.SUB_STREAM'|translate }}</th>
                    <th class="info-col">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.INFO'|translate }}</th>
                    <th class="type-col">{{ 'COMMON.TYPE'|translate }}</th>
                    <th class="audio-col">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.AUDIO'|translate }}</th>
                    <th class="storage-col">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STORAGE'|translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (config of cameraConfigsArray; track config.id) {
                <tr>
                    <td class="checkbox-col">
                        <mat-checkbox [checked]="isCameraSelected(config.id)"
                            (change)="toggleCameraSelection(config.id)"></mat-checkbox>
                    </td>
                    <td class="cameras-col">
                        <div class="camera-info">
                            <div class="camera-thumbnail">
                                @if (config.connectionDetails?.mainStreamConnectionData?.snapshotUrl) {
                                <img [appAuthSrc]="getSnapshotUrl(config.connectionDetails.mainStreamConnectionData.snapshotUrl)"
                                    [appAuthSrcFallback]="getSnapshotFallbackUrl(config.connectionDetails.mainStreamConnectionData.snapshotUrl)"
                                    [attr.alt]="'ADD_CAMERA_WIZARD.COMMON.CAMERA_SNAPSHOT_ALT'|translate" />
                                } @else {
                                <div class="thumbnail-placeholder">
                                    <span class="ui-icon-camera"></span>
                                </div>
                                }
                            </div>
                            <div class="camera-name-section">
                                <input class="ui-input camera-name-input" type="text" [value]="config.name"
                                    (input)="onCameraNameChange(config.id, $any($event.target).value)"
                                    matTooltip="{{ config.name }}" matTooltipPosition="above" />
                            </div>
                        </div>
                    </td>
                    <td class="autoconfig-col">
                        <span class="ui-icon-checkmark" [class.enabled]="config.autoConfigure"></span>
                    </td>
                    <td class="mainstream-col">
                        <span [class]="getStreamOptimizationIcon(config, 'mainstream')" 
                            [matMenuTriggerFor]="mainstreamMenu"
                            [matTooltip]="getStreamStatusTooltip(config, 'mainstream') | translate"
                            matTooltipPosition="above"
                            class="stream-status-icon"></span>
                        
                        <!-- Mainstream Status Menu -->
                        <mat-menu #mainstreamMenu="matMenu" class="stream-status-menu" xPosition="before">
                            <div class="stream-wrapper flex-col" (click)="$event.stopPropagation()" [class.not-optimized]="hasSetToValues(config, 'mainstream')">
                                <div class="flex-row space-between-center stream-header">
                                    <div class="flex-row gap-8 start-center">
                                        <span [class]="getStreamOptimizationIcon(config, 'mainstream')"></span>
                                        <div class="stream-title">{{ getStreamMenuTitle(config, 'mainstream') | translate }}</div>
                                    </div>
                                    <span class="ui-icon-close c-p"></span>
                                </div>
                                
                                <div class="stream-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th class="spacer"></th>
                                                <th>{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STREAM_TABLE.CURRENT'|translate }}</th>
                                                @if (hasSetToValues(config, 'mainstream')) {
                                                <th>{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STREAM_TABLE.SET_TO'|translate }}</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (row of getStreamDetailRows(config, 'mainstream'); track row.label) {
                                            <tr>
                                                <td class="label-cell">{{ row.label | translate }}</td>
                                                <td class="value-cell">{{ row.current }}</td>
                                                @if (hasSetToValues(config, 'mainstream')) {
                                                <td class="setTo-cell">{{ row.setTo || '' }}</td>
                                                }
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </mat-menu>
                    </td>
                    <td class="substream-col">
                        @if (config.connectionDetails?.subStreamConnectionData?.connectionResponseCode) {
                        <span [class]="getStreamOptimizationIcon(config, 'substream')" 
                            [matMenuTriggerFor]="substreamMenu"
                            [matTooltip]="getStreamStatusTooltip(config, 'substream') | translate"
                            matTooltipPosition="above"
                            class="stream-status-icon"></span>
                        
                        <!-- Substream Status Menu -->
                        <mat-menu #substreamMenu="matMenu" class="stream-status-menu" xPosition="before">
                            <div class="stream-wrapper flex-col" (click)="$event.stopPropagation()" [class.not-optimized]="hasSetToValues(config, 'substream')">
                                <div class="flex-row space-between-center stream-header">
                                    <div class="flex-row gap-8 start-center">
                                        <span [class]="getStreamOptimizationIcon(config, 'substream')"></span>
                                        <div class="stream-title">{{ getStreamMenuTitle(config, 'substream') | translate }}</div>
                                    </div>
                                    <span class="ui-icon-close c-p"></span>
                                </div>
                                
                                <div class="stream-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STREAM_TABLE.CURRENT'|translate }}</th>
                                                @if (hasSetToValues(config, 'substream')) {
                                                <th>{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STREAM_TABLE.SET_TO'|translate }}</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (row of getStreamDetailRows(config, 'substream'); track row.label) {
                                            <tr>
                                                <td class="label-cell">{{ row.label | translate }}</td>
                                                <td class="value-cell">{{ row.current }}</td>
                                                @if (hasSetToValues(config, 'substream')) {
                                                <td class="setTo-cell">{{ row.setTo || '' }}</td>
                                                }
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </mat-menu>
                        } @else {
                        <span class="ui-icon-minus status-none"></span>
                        }
                    </td>
                    <td class="info-col">
                        <span class="ui-icon-info info-button" 
                            [matMenuTriggerFor]="cameraInfoMenu"></span>
                        
                        <!-- Camera Info Menu -->
                        <mat-menu #cameraInfoMenu="matMenu" class="camera-info-menu" xPosition="before">
                            <div class="info-wrapper flex-col" (click)="$event.stopPropagation()">
                                <div class="flex-row space-between-center info-header">
                                    <div class="info-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.INFO'|translate }}</div>
                                    <span class="ui-icon-close c-p"></span>
                                </div>
                                
                                <hr class="hr">
                                
                                <div class="info-row flex-row space-between-center">
                                    <div class="info-label">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.INFO_IP'|translate }}</div>
                                    <div class="info-value">{{ getCameraIp(config) }}</div>
                                </div>
                                
                                <hr class="hr">
                                
                                <div class="info-row flex-row space-between-center">
                                    <div class="info-label">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.INFO_MAC'|translate }}</div>
                                    <div class="info-value">{{ getCameraMac(config) }}</div>
                                </div>
                                
                                <div class="info-row flex-row space-between-center">
                                    <div class="info-label">{{ 'CAMERA_TABLE.BRAND'|translate }}</div>
                                    <div class="info-value">{{ getCameraBrand(config) }}</div>
                                </div>
                                
                                <div class="info-row flex-row space-between-center gap-8">
                                    <div class="info-label">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.INFO_PING_MS'|translate }}</div>
                                    <div class="flex-row gap-8">
                                        <div class="metadata-chip">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.PING_AVG'|translate }}: —</div>
                                        <div class="metadata-chip">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.PING_MAX'|translate }}: —</div>
                                        <div class="metadata-chip">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.PING_MIN'|translate }}: —</div>
                                        <div class="metadata-chip">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.PING_STDEV'|translate }}: —</div>
                                    </div>
                                </div>
                                
                                <div class="info-row flex-row space-between-center">
                                    <div class="info-label">{{ 'CAMERA_TABLE.CONNECTION.HEADER'|translate }}</div>
                                    <div class="info-value flex-row gap-8 end-center">
                                        <span class="connection-dot" [class]="getConnectionStatusClass(config)"></span>
                                        {{ getConnectionStatusText(config) | translate }}
                                    </div>
                                </div>
                                
                                <div class="info-row flex-row space-between-center">
                                    <div class="info-label">{{ 'ADD_CAMERA_WIZARD.AUTH.PROTOCOL'|translate }}</div>
                                    <div class="info-value">{{ getCameraProtocol(config) | translate }}</div>
                                </div>
                            </div>
                        </mat-menu>
                    </td>
                    <td class="type-col">
                        {{ getCameraTypeText(config) | translate }}
                    </td>
                    <td class="audio-col">
                        @if (config.audioMainStreamEnabled && config.audioSubStreamEnabled) {
<!--                        <span class="ui-icon-audio"></span>-->
                        } @else {
                        <span class="ui-icon-mute"></span>
                        }
                    </td>
                    <td class="storage-col">
                        <div class="storage-info">
                            <div class="storage-days">
                                <span class="ui-icon-clock"></span>
                                {{ getStorageDaysText(config) }}
                            </div>
                            <div class="storage-stream">
                                {{ getStorageStreamText(config) | translate }}
                            </div>
                            @if (config.smartStorageEnabled) {
                            <div class="smart-storage-badge">
                                {{ 'ADD_CAMERA_WIZARD.CONFIGURATION.SMART_STORAGE'|translate }}
                            </div>
                            }
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>

</div>